import ZObject from '../ZObject.js';
export default superclass => class extends superclass {

    initShaderBackground() {
        this.scene = new ZObject(this.subSequence);
        this.scene.text = "three.scene";

        this.render = new ZObject(this.subSequence);
        this.render.text = "three.render";

        this.canvas = new ZObject(this.subSequence);
        this.canvas.text = "three.canvas";

        this.camera = new ZObject(this.subSequence);
        this.camera.text = "three.orthographicCamera 0 201 0 227 -1 1";

        this.render.connectInlet("camera", this.camera, "Output 1");
        this.render.connectInlet("Input", this.scene, "Output 1");
        this.canvas.effect.connectInlet("operation", this.render, "Output 1");
        this.camera.bang();

        this.newInlet("background scene", (msg) => {
            this.showCanvas = true;
            this.scene.onInputMessage(msg);
        });

    }
}
